
export class CategoryMappingCsvUploadResult
{
    UploadErrors: string[] = [];

    constructor(json?: any)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);
        }
    }
}
